
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersDay as ObiLightningLightRainShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-day.js';
 
 
 

 
 export const ObiLightningLightRainShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-day',
   elementClass: ObiLightningLightRainShowersDayElement,
   events: {
     
   }
  });
 
 